import React, { useState, useEffect } from 'react';
import './Snowfall.css';

const KOREAN_LETTERS = [
  'ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ',
  'ㅏ', 'ㅑ', 'ㅓ', 'ㅕ', 'ㅗ', '요', 'ㅜ', 'ㅠ', 'ㅡ', 'ㅣ',
  '한', '국', '어', '꽃', '사', '랑', '봄', '서', '울', '행', '복'
];

const COLORS = [
  '#ff7675', '#74b9ff', '#55efc4', '#ffeaa7', '#a29bfe',
  '#fd79a8', '#fdcb6e', '#00cec9', '#e84393', '#6c5ce7',
  '#ffbe76', '#ff7979', '#badc58', '#dff9fb', '#f6e58d'
];

export default function Snowfall() {
  const [flakes, setFlakes] = useState([]);

  useEffect(() => {
    const arr = Array.from({ length: 55 }).map((_, i) => {
      const isLetter = Math.random() > 0.35;
      const left = Math.random() * 100;
      const delay = Math.random() * -20;
      const duration = Math.random() * 14 + 8;
      const opacity = Math.random() * 0.5 + 0.4;
      const sway = Math.random() * 80 - 40;
      
      let size, char, color, className;
      
      if (isLetter) {
        size = Math.random() * 10 + 12;
        char = KOREAN_LETTERS[Math.floor(Math.random() * KOREAN_LETTERS.length)];
        color = COLORS[Math.floor(Math.random() * COLORS.length)];
        className = 'snowflake snowflake-letter';
      } else {
        size = Math.random() * 4 + 3;
        char = null;
        color = null;
        className = 'snowflake snowflake-dot';
      }

      return {
        id: i,
        isLetter,
        char,
        className,
        style: {
          left: `${left}%`,
          width: isLetter ? 'auto' : `${size}px`,
          height: isLetter ? 'auto' : `${size}px`,
          opacity: opacity,
          color: color,
          fontSize: isLetter ? `${size}px` : undefined,
          animation: `fall ${duration}s linear infinite`,
          animationDelay: `${delay}s`,
          '--sway': `${sway}px`,
          '--opacity': opacity
        }
      };
    });
    setFlakes(arr);
  }, []);

  return (
    <div className="snow-container">
      {flakes.map((f) => (
        <div key={f.id} className={f.className} style={f.style}>
          {f.isLetter ? f.char : null}
        </div>
      ))}
    </div>
  );
}
